// export const BASE_URL = "http://metagymdev.exbody.com:59882/";
// export const BASE_URL = "https://metagymdev.exbody.com:60010/v1/";

const DEV_URL = 'https://metagymdev.exbody.com:59886/';
const LIVE_URL = 'https://ebapi.exbody.metafamily.world/';
const QA_URL = 'https://ebapi.exbody.qa.metafamily.world/';
const LOCAL_URL = 'https://metagymdev.exbody.com:59886/';
//const LOCAL_URL = 'http://localhost:59887/';

export const BASE_URL = window.location.origin.includes('biz.exbody.com')
  ? LIVE_URL
  : window.location.origin.includes('qa')
  ? QA_URL
  : window.location.origin.includes('metagymdev')
  ? DEV_URL
  : LOCAL_URL;

const DEV_JOIN_URL = 'https://metagymdev.exbody.com:59886/';
const LIVE_JOIN_URL = 'https://ebapi.exbody.metafamily.world/';
const QA_JOIN_URL = 'https://ebapi.exbody.qa.metafamily.world/';
//const LOCAL_JOIN_URL = 'http://localhost:59887/';
const LOCAL_JOIN_URL = 'https://metagymdev.exbody.com:59886/';

export const BASE_JOIN_URL = window.location.origin.includes('biz.exbody.com')
  ? LIVE_JOIN_URL
  : window.location.origin.includes('qa')
  ? QA_JOIN_URL
  : window.location.origin.includes('metagymdev')
  ? DEV_JOIN_URL
  : LOCAL_JOIN_URL;

const DEV_MAIN_URL = 'https://metagymdev.exbody.com:59881/';
export const BASE_MAIN_URL = DEV_MAIN_URL;
